module.exports = __webpack_public_path__ + "static/media/menu-icon.5d860177.svg";